import { Badge } from "@/components/ui/badge";

interface JobSkillsProps {
  skills: string[];
  showTitle?: boolean;
  titleText?: string;
  titleClassName?: string;
  containerClassName?: string;
  skillsContainerClassName?: string;
  skillBadgeClassName?: string;
  maxSkills?: number; // Limit number of skills shown
  showMoreBadge?: boolean; // Show "+X more" badge when skills are limited
  moreBadgeClassName?: string;
}

export function JobSkills({ 
  skills,
  showTitle = true,
  titleText = "Required Skills",
  titleClassName = "text-lg font-semibold text-gray-900",
  containerClassName = "space-y-4 pt-6 border-t",
  skillsContainerClassName = "flex flex-wrap gap-2",
  skillBadgeClassName = "bg-orange-100 text-orange-700 border-0 space-grotesk text-xs",
  maxSkills,
  showMoreBadge = true,
  moreBadgeClassName = "bg-slate-100 text-slate-600"
}: JobSkillsProps) {
  if (!skills || skills.length === 0) {
    return null;
  }

  const displaySkills = maxSkills ? skills.slice(0, maxSkills) : skills;
  const remainingCount = maxSkills && skills.length > maxSkills ? skills.length - maxSkills : 0;

  return (
    <div className={containerClassName}>
      {showTitle && (
        <h3 className={titleClassName}>{titleText}</h3>
      )}
      <div className={skillsContainerClassName}>
        {displaySkills.map((skill) => (
          <Badge key={skill} className={skillBadgeClassName}>
            {skill}
          </Badge>
        ))}
        {remainingCount > 0 && showMoreBadge && (
          <Badge variant="secondary" className={moreBadgeClassName}>
            +{remainingCount} more
          </Badge>
        )}
      </div>
    </div>
  );
}
